import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import update from 'immutability-helper'
import { Button } from '@resurs/midas-react'
import { getText } from '../../../../../internal/TextLabels'
import Frame from '../Frame'
import LoaderOverlay from '../../../../../internal/LoaderOverlay'
import styles from './styles.module.scss'
import {
  redeemBonusCheck,
  updateBonusCheck,
  clearRedeemResult,
} from '../../../../../store/actions/bonus-check-actions'

const getCouponStyle = check => {
  if (check.fade) {
    return styles.couponFading
  }
  if (check.status === 'VALID') {
    return styles.coupon
  }
  return styles.hidden
}

class BonusChecks extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      checks: [],
    }
  }

  UNSAFE_componentWillMount() { //eslint-disable-line
    this.setState({
      checks: this.props.bonusChecks,
    })
  }

  UNSAFE_componentWillReceiveProps(nextProps) { //eslint-disable-line
    if (nextProps.redeemResult && nextProps.redeemResult.reference) {
      if (nextProps.redeemResult.success) {
        const tmpCheck = nextProps.redeemResult
        tmpCheck.fade = true
        tmpCheck.pending = false
        this.startFade(tmpCheck)
      } else if (nextProps.redeemResult.success === false) {
        this.hideCheck(nextProps.redeemResult)
      }
      this.props.clearRedeemResult()
    }
  }

  hideCheck(check) {
    this.setState(state =>
      update(state, {
        checks: {
          $set: state.checks.filter(c => c.reference !== check.reference),
        },
      }),
    )
    this.props.updateBonusCheck(check)
  }

  startFade(check) {
    this.setState(
      state =>
        update(state, {
          checks: {
            $set: state.checks.map(c =>
              c.reference === check.reference ? check : c,
            ),
          },
        }),
      () => {
        setTimeout(() => this.hideCheck(check), 1000)
      },
    )
  }

  redeemBonus(e, check) {
    e.preventDefault()
    this.setState(state =>
      update(state, {
        checks: {
          $set: state.checks.map(c => ({
            ...c,
            pending: c.reference === check.reference ? true : c.pending,
          })),
        },
      }),
    )

    this.props.redeemBonusCheck(
      this.props.governmentId,
      this.props.customerType,
      check.reference,
    )
    this.props.bonusCheckRedeem(
      this.props.governmentId,
      this.props.customerType,
      check.reference,
    )
  }

  render() {
    return (
      <Frame>
        {this.state.checks.map(check => (
          <div key={check.reference} className={getCouponStyle(check)}>
            <LoaderOverlay loading={check.pending}>
              <div className={styles.couponRow}>
                <div className={styles.leftSide}>
                  <span className={styles.titleStyle}>
                    {getText('bonusChecks.bonusCheck')}
                  </span>
                  <p className={styles.amountStyle}>
                    {getText('bonusChecks.amount', check.amount)}
                  </p>
                  <span className={styles.refStyle}>
                    {getText('bonusChecks.reference')}: {check.reference}
                  </span>
                  <div>
                    <span className={styles.validUntil}>
                      {getText('bonusChecks.validUntil')} {check.validUntil}
                    </span>
                  </div>
                </div>
                <div
                  className={
                    check.fade ? styles.rightSideFading : styles.rightSide
                  }
                >
                  <Button onClick={e => this.redeemBonus(e, check)}>
                    {getText('bonusChecks.redeemBonus')}
                  </Button>
                </div>
              </div>
            </LoaderOverlay>
          </div>
        ))}
      </Frame>
    )
  }
}

BonusChecks.propTypes = {
  bonusChecks: PropTypes.array.isRequired,
  governmentId: PropTypes.string.isRequired,
  customerType: PropTypes.string.isRequired,
  redeemBonusCheck: PropTypes.func.isRequired,
  redeemResult: PropTypes.object.isRequired, //eslint-disable-line
  updateBonusCheck: PropTypes.func.isRequired,
  clearRedeemResult: PropTypes.func.isRequired,
}

const mapStateToProps = state => {
  return {
    bonusChecks: state.bonusCheck.bonusChecks,
    redeemResult: state.bonusCheck.redeemResult,
    governmentId: state.payApply.current && state.payApply.current.governmentId,
    customerType:
      state.payApply.current.selectedPaymentMethod &&
      state.payApply.current.selectedPaymentMethod.customerType,
  }
}

const mapDispatchToProps = dispatch => ({
  redeemBonusCheck: (governmentId, customerType, reference) => {
    dispatch(redeemBonusCheck(governmentId, customerType, reference))
  },
  updateBonusCheck: check => {
    dispatch(updateBonusCheck(check))
  },
  clearRedeemResult: () => {
    dispatch(clearRedeemResult())
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(BonusChecks)
